import { InjectionToken } from '@angular/core';
import { ImageGallerySelector } from './lightbox.service';

export const IMAGE_TOKEN = new InjectionToken<ImageGallerySelector>('IMAGE_TOKEN');
